import { Box } from '@mui/material'
import { playLargeIcon } from '../../assets/index'
import { BUTTON_TRANSITION } from '../../theme/buttonHover'

/** Outer ring + padding must leave room for a true circle on tablet (sm/md). xs + lg unchanged. */
const outerRingSx = {
  boxSizing: 'border-box',
  width: { xs: 72, sm: 72, md: 80, lg: 86 },
  height: { xs: 72, sm: 72, md: 80, lg: 86 },
  minWidth: { xs: 72, sm: 72, md: 80, lg: 86 },
  minHeight: { xs: 72, sm: 72, md: 80, lg: 86 },
  p: { xs: '14px', sm: '12px', md: '11px', lg: '14px' },
}

const innerCircleSx = {
  boxSizing: 'border-box',
  width: { xs: 52, sm: 48, md: 58, lg: 58 },
  height: { xs: 52, sm: 48, md: 58, lg: 58 },
  minWidth: { xs: 52, sm: 48, md: 58, lg: 58 },
  minHeight: { xs: 52, sm: 48, md: 58, lg: 58 },
  flexShrink: 0,
  aspectRatio: '1 / 1',
}

const playIconSx = {
  width: { xs: 16, sm: 16, md: 17, lg: 18 },
  height: { xs: 16, sm: 16, md: 17, lg: 18 },
  flexShrink: 0,
  objectFit: 'contain',
  display: 'block',
}

export default function PlayPauseButton({
  isPlaying,
  onClick,
  decorative = false,
  size,
  innerSize,
  iconSize,
  ariaLabel,
  sx = {},
}) {
  const isInteractive = !decorative && typeof onClick === 'function'
  const useFixedSize = size != null

  return (
    <Box
      component={isInteractive ? 'button' : 'div'}
      type={isInteractive ? 'button' : undefined}
      onClick={isInteractive ? onClick : undefined}
      aria-hidden={decorative ? true : undefined}
      aria-label={
        decorative ? undefined : ariaLabel ?? (isPlaying ? 'Pause video' : 'Play video')
      }
      sx={{
        borderRadius: '50%',
        bgcolor: 'rgba(8,39,83,0.4)',
        backdropFilter: 'blur(10px)',
        border: 'none',
        cursor: isInteractive ? 'pointer' : 'default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        transition: BUTTON_TRANSITION,
        '&:hover': { transform: 'scale(1.04)' },
        ...(useFixedSize
          ? {
              boxSizing: 'border-box',
              width: size,
              height: size,
              minWidth: size,
              minHeight: size,
              p: '14px',
            }
          : outerRingSx),
        ...sx,
      }}
    >
      <Box
        sx={{
          borderRadius: '50%',
          bgcolor: '#fffefa',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...(useFixedSize
            ? {
                boxSizing: 'border-box',
                width: innerSize ?? 58,
                height: innerSize ?? 58,
                minWidth: innerSize ?? 58,
                minHeight: innerSize ?? 58,
                flexShrink: 0,
                aspectRatio: '1 / 1',
              }
            : innerCircleSx),
        }}
      >
        {isPlaying ? (
          <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
            <Box sx={{ width: 4, height: 14, bgcolor: '#082753', borderRadius: '1px' }} />
            <Box sx={{ width: 4, height: 14, bgcolor: '#082753', borderRadius: '1px' }} />
          </Box>
        ) : (
          <Box
            component="img"
            src={playLargeIcon}
            alt=""
            sx={
              useFixedSize
                ? {
                    width: iconSize ?? 18,
                    height: iconSize ?? 18,
                    objectFit: 'contain',
                    display: 'block',
                  }
                : playIconSx
            }
          />
        )}
      </Box>
    </Box>
  )
}
